import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import { CheckCircle, XCircle, Loader, Delete } from 'react-feather';
import getLabel from '../../translations/messages';
import { fetchUpload } from '../../cruds/remote';
import { classNames } from '../../functions/classNames';
import './InputUpload.css';

const UPLOADING = 'uploading';
const OK = 'ok';
const ERROR = 'error';
const REJECTED = 'rejected';
const DELETED = 'deleted';

class InputUpload extends Component {
  constructor(props, context) {
    super(props, context);
    this.initState(props);
  }

  initState = props => {
    const state = props.value ?
      props.value.map(file => ({ status: OK, ...file }))
          .reduce((state, file, idx) => {
            state[idx] = file;
            return state;
          }, {}) : {};

    this.state = state;
    this.lastIndex = Object.keys(state).length;
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.reset) {
      this.lastIndex = 0;
      this.state = {};
    }
  }

  onFileUploading = (file, index) => {
    this.setState({
      [index]: {
        name: file.name,
        status: UPLOADING,
      }
    });
  };

  onFileUploaded = (file, index, uuid) => {
    this.setState({
      [index]: {
        name: file.name,
        status: OK,
        uuid: uuid,
      },
    }, this.onChange);
  };

  onUploadError = (file, index, message) => {
    this.setState({
      [index]: {
        name: file.name,
        status: ERROR,
        message: message,
      },
    }, this.checkLockSubmit);
  };

  onFileRejected = (file, index) => {
    this.setState({
      [index]: {
        name: file.name,
        status: REJECTED,
      }, });
  };

  onFileRemoved = (index) => {
    if (window.confirm(getLabel(this.context.locale, 'general.confirmDeletion.text'))) {
      let updated = { ...this.state[index] };
      updated.status = DELETED;
      this.setState({ [index]: updated }, this.onChange);

    }
  };

  onChange = () => {
    const value = Object.keys(this.state)
                      .map(k => this.state[k])
                      .filter(f => f.status === OK)
                      .map(f => ({ uuid: f.uuid, name: f.name }));

    this.props.handleChange({
      target: {
        name: this.props.name,
        value: value,
      },
    });

    this.checkLockSubmit();
  };

  checkLockSubmit = () => {
    const isStillUploading = Object.keys(this.state)
                                    .map(k => this.state[k])
                                    .filter(f => f.status === UPLOADING)
                                    .length > 0;
    if( !isStillUploading ) {
      this.props.handleLockSubmit(false)
    }
  };

  getIndex = () => {
    return this.lastIndex++;
  };

  handleDrop = (accepted, rejected) => {
    if( accepted.length > 0 ) {
      this.props.handleLockSubmit(true)
    }

    accepted.forEach(f => {
      const index = this.getIndex();

      this.onFileUploading(f, index);

      fetchUpload(this.props.to, f)
          .then(res => this.onFileUploaded(f, index, res.value))
          .catch(err => this.onUploadError(f, index, err.value));
    });

    rejected.forEach(f => {
      this.onFileRejected(f, this.getIndex());
    });
  };

  renderIcon = (status) => {
    if (status === UPLOADING) {
      return <Loader size={17} />;
    }

    if (status === OK) {
      return <CheckCircle size={17} />;
    }

    if (status === ERROR) {
      return <XCircle size={17} />;
    }

    if (status === REJECTED) {
      return <XCircle size={17} />;
    }

    return '';
  };

  renderStatus = (status) => {
    const { locale } = this.context;

    if (status === ERROR) {
      return getLabel(locale, 'general.dropzone.error');
    }

    if (status === REJECTED) {
      return getLabel(locale, 'general.dropzone.rejected');
    }

    return '';
  };

  renderDeleteButton = (file, index) => {
    if (file.status !== OK) {
      return <div style={{ visibility: 'hidden' }}><Delete size={17}/></div>;
    }

    return (
      <a onClick={() => this.onFileRemoved(index)}>
        <Delete size={17}/>
      </a>
    );
  };

  renderFile = (f, i) => (
    <div key={i} className={classNames('file-row', f.status)}>
      <div className="remove-button">{this.renderDeleteButton(f, i)}</div>
      <div className="file-name">{f.name}</div>
      <div className="status-icon">{this.renderIcon(f.status)}</div>
      <div className="status-message">{this.renderStatus(f.status)}</div>
    </div>
  );

  renderFileList = () => {
    return (
      <div className="file-list">
        {Object.keys(this.state)
            .filter(k => this.state[k].status !== DELETED)
            .map(k => this.renderFile(this.state[k], k))
        }
      </div>
    );
  };

  render() {
    const { label, style } = this.props;
    const { locale } = this.context;

    return (



<div className={classNames('InputUpload', this.props.error ? 'hasError' : '')} style={style}>
        <div className="title">{getLabel(locale, label)} {this.props.required ? <span className="required">*</span> : ''}</div>
        <div className="content">
          <div className="left">
            <Dropzone
              ref={(node) => { this.dropzoneRef = node; }}

              onDrop={this.handleDrop}
              maxSize={10 * 1024 * 1024}
              className="dropzone"
            >
              <p className="dropzone-placeholder">{getLabel(locale, 'general.dropzone.content')}</p>
            </Dropzone>
            <button className="Button btn-orange" type="button" onClick={() => { this.dropzoneRef.open(); }}>
              {getLabel(locale, 'general.dropzone.button')}
            </button>
          </div>
          <div className="right">
            {this.renderFileList()}
          </div>
        </div>
      </div>
    );
  }

}

InputUpload.contextTypes = {
  locale: PropTypes.string,
};

export default InputUpload;



// WEBPACK FOOTER //
// ./src/main/components/input/InputUpload.js